import { Injectable } from "@angular/core";
import { SegmentsService } from "../services/segments.service";
import { AppState } from "src/app/core/app.state";
import { Store } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, finalize, map, of, switchMap, tap } from "rxjs";
import { ISegment } from "../models/segment.model";
import { APIResponse } from "src/app/core/models/api-response";
import * as segmentsActions from './segments.actions'
import { SetLoading } from "src/app/shared/store/shared.actions";
import { CommonService } from "src/app/shared/common.service";
import { AlertEnums } from "src/app/shared/enums/shared.enums";
import { TranslateService } from "@ngx-translate/core";
import { DEFAULT_PAGE_SIZE } from "src/app/config/global.config";

@Injectable()
export class SegmentsEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private segmentsServices: SegmentsService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }


  fetchAllSegmentsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(segmentsActions.FetchAllSegments),
      tap(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: true }))),
      switchMap(({ includes }) =>
        this.segmentsServices.fetchAllSegments(includes).pipe(
          map((response: APIResponse<ISegment>) => segmentsActions.FetchAllSegmentsSuccess({ allSegments: response.data })),
          catchError(() => of(segmentsActions.FetchAllSegmentsError())),
          finalize(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: false })))
        )
      )
    )
  );


  fetchSegmentsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(segmentsActions.FetchSegments),
      tap(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: true }))),
      switchMap((action) =>
        this.segmentsServices.fetchSegments(action.page, action.filter, action.key).pipe(
            map((response: APIResponse<ISegment>) => segmentsActions.FetchSegmentsSuccess({ segments: response })),
            catchError(() => of(segmentsActions.FetchSegmentsError())),
            finalize(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: false })))
          )
      )
    )
  );

  addSermentEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(segmentsActions.AddSegment),
      tap(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: true }))),
      switchMap((action) =>
        this.segmentsServices.addSegment(action.segment).pipe(
          map((response: APIResponse<ISegment>) => segmentsActions.AddSegmentSuccess({ segment: response.data[0] })),
          tap(() => {
            this.store.dispatch(segmentsActions.FetchSegments({ page: { number: 1, size: DEFAULT_PAGE_SIZE } }));
            this.commonService.showToast(
              this.translateService.instant(`alerts.${AlertEnums.segmentAddSuccess}`),
              'SUCCESS'
            )
          }),
          catchError(() => of(segmentsActions.AddSegmentError())),
          finalize(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: false })))
        )
      )
    )
  );

  updateSermentEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(segmentsActions.UpdateSegment),
      tap(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: true }))),
      switchMap((action) =>
        this.segmentsServices.updateSegment(action.id, action.segment).pipe(
          map((response: APIResponse<ISegment>) => segmentsActions.UpdateSegmentSuccess({ segment: response.data[0] })),
          tap(() => {
            this.store.dispatch(segmentsActions.FetchSegments({ page: { number: 1, size: DEFAULT_PAGE_SIZE } }));
            this.commonService.showToast(this.translateService.instant(`alerts.${AlertEnums.segmentUpdateSuccess}`), 'SUCCESS')
          }),
          catchError(() => of(segmentsActions.UpdateSegmentError())),
          finalize(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: false })))
        )
      )
    )
  );
  // delete Segment
  DeleteSegmentEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(segmentsActions.DeleteSegments),
      tap(() => this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: true }))),
      switchMap((action) =>
        this.segmentsServices.deleteSegment(action.id).pipe(
          map(() => segmentsActions.DeleteSegmentsSuccess()),
          tap(() => {
            this.commonService.showToast(
              this.translateService.instant(`alerts.${AlertEnums.segmentDeleteSuccess}`),
              'SUCCESS'
            );
          }),
          catchError(() => of(segmentsActions.DeleteSegmentsError())),
          finalize(() => {
            this.store.dispatch(segmentsActions.SetSegmentsLoader({ isLoading: false }));
          })
        )
      )
    )
  );

}
